module.exports = __webpack_public_path__ + "img/goldregen-2020-018.533c4f1f.jpg";